import e from "react";
import { componentName as t } from "../../../utils/bem/index.js";
function c(c) {
  var i = c.fillColor,
    a = c.height,
    l = c.width,
    o = c.viewBox,
    r = c.avatar,
    m = t("account-circle", c.className, {
      customAvatar: !!r
    });
  return r ? e.createElement("img", {
    className: m,
    src: r
  }) : e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: void 0 === l ? "24" : l,
    height: void 0 === a ? "24" : a,
    viewBox: void 0 === o ? "0 0 20 20" : o,
    className: m
  }, e.createElement("path", {
    fill: void 0 === i ? "#FFF" : i,
    fillRule: "evenodd",
    d: "M10 1.667A8.336 8.336 0 0 0 1.667 10c0 4.6 3.733 8.333 8.333 8.333S18.333 14.6 18.333 10 14.6 1.667 10 1.667zm0 2.5c1.383 0 2.5 1.116 2.5 2.5 0 1.383-1.117 2.5-2.5 2.5a2.497 2.497 0 0 1-2.5-2.5c0-1.384 1.117-2.5 2.5-2.5zM10 16a6 6 0 0 1-5-2.683c.025-1.659 3.333-2.567 5-2.567 1.658 0 4.975.908 5 2.567A6 6 0 0 1 10 16z"
  }));
}
c.displayName = "AccountCircle";
export { c as AccountCircle };